// strv-standard: toast v1.0.0
// Master copy lives in strvcom/strv-it-hub /standard. Copy unchanged.

import { el } from './dom.js';

let host;

/**
 * Show a short message in the corner.
 * @param {string} text
 * @param {{ kind?: 'info' | 'success' | 'error', ms?: number, action?: { label: string, run: () => void } }} [opts]
 */
export function toast(text, { kind = 'info', ms = 4000, action } = {}) {
  if (!host || !host.isConnected) {
    host = el('div', { class: 'toasts', role: 'status', 'aria-live': 'polite' });
    document.body.append(host);
  }
  const item = el(
    'div',
    { class: 'toast', dataset: { kind } },
    el('span', {}, text),
    action
      ? el('button', {
          class: 'btn btn-ghost btn-sm',
          onclick: () => {
            action.run();
            item.remove();
          },
        }, action.label)
      : null,
  );
  host.append(item);
  setTimeout(() => item.remove(), ms);
  return item;
}
